////////LIBRARY/////////
import update from 'immutability-helper'
import { cloneDeep, findIndex } from 'lodash'
///////COMPONENTS///////
import extendUpdate from '../../helpers/extendUpdate'
import ActionsTypes from '../../constants/ActionsTypes'

extendUpdate(update)

const consignation = {
	[ActionsTypes.POST_CONSIGNATION]: (state) =>
		update(state, {
			consignation: {
				isLoading: {
					$set: true,
				},
				error: {
					$set: false,
				},
				items: {
					$set: [],
				},
			},
			columns: {
				isSearchfieldUpdated: {
					$set: false,
				},
				currentDir: {
					$set: '',
				},
				currentColumn: {
					$set: '',
				},
			},
		}),
	[ActionsTypes.POST_CONSIGNATION_SUCCESS]: (state, payload) => {
		const payloadFiltersCP = cloneDeep(payload.data.headerParam.filters)
		const itemsConf = cloneDeep(payload.data.headerContent.contentPagined.content)

		const pagingFilter = {
			totalElements: payload.data.headerContent.contentPagined.totalElements,
			totalPages: payload.data.headerContent.contentPagined.totalPages,
		}

		itemsConf.forEach((elem) => (elem['selected'] = false))

		return update(state, {
			consignation: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: false,
				},
				items: {
					$set: itemsConf,
				},
				paging: {
					$set: pagingFilter,
				},
				header: {
					$set: payloadFiltersCP,
				},
			},
		})
	},
	[ActionsTypes.POST_CONSIGNATION_FAILURE]: (state, payload) => {
		return update(state, {
			error: {
				$set: payload.error,
			},
		})
	},

	[ActionsTypes.UPDATE_CUSTOMER_INFOS]: (state) =>
		update(state, {
			consignation: {
				isLoading: {
					$set: true,
				},
				update: {
					$set: false,
				},
			},
		}),
	[ActionsTypes.UPDATE_CUSTOMER_INFOS_SUCCESS]: (state, payload) => {
		const consignationCP = cloneDeep(state.consignation.items)
		const idx = findIndex(consignationCP, { saleOrderId: payload.customer.salesOrderId })

		consignationCP[idx].clientLastName = payload.customer.customerInfos.customerLastName
		consignationCP[idx].clientFirstName = payload.customer.customerInfos.customerFirstName
		consignationCP[idx].clientEmail = payload.customer.customerInfos.customerEmail

		return update(state, {
			consignation: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: false,
				},
				update: {
					$set: true,
				},
				items: {
					$set: consignationCP,
				},
			},
		})
	},
	[ActionsTypes.UPDATE_CUSTOMER_INFOS_FAILURE]: (state, payload) => {
		return update(state, {
			consignation: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: payload.error,
				},
			},
		})
	},

	[ActionsTypes.SEND_CONSIGNEMENT_CONTRACT]: (state) =>
		update(state, {
			consignation: {
				isLoading: {
					$set: true,
				},
				contractSend: {
					$set: false,
				},
				isUpdated: {
					$set: false,
				},
			},
		}),
	[ActionsTypes.SEND_CONSIGNEMENT_CONTRACT_SUCCESS]: (state, _payload) => {
		return update(state, {
			consignation: {
				isLoading: {
					$set: false,
				},
				contractSend: {
					$set: true,
				},
				isUpdated: {
					$set: true,
				},
			},
		})
	},
	[ActionsTypes.SEND_CONSIGNEMENT_CONTRACT_FAILURE]: (state, payload) => {
		return update(state, {
			consignation: {
				isLoading: {
					$set: false,
				},

				error: {
					$set: payload.error,
				},
			},
		})
	},
	[ActionsTypes.GET_TRANSACTION_NUMBER]: (state, payload) => {
		let transactionNumber = payload.transactionNumber

		return update(state, {
			salesHistoryManager: {
				transactionNumber: {
					$set: transactionNumber,
				},
			},
		})
	},
	[ActionsTypes.RESET_TRANSACTION_NUMBER]: (state) => {
		return update(state, {
			salesHistoryManager: {
				transactionNumber: {
					$set: '',
				},
			},
		})
	},

	[ActionsTypes.VIEW_CONSIGNEMENT_CONTRACT]: (state) =>
		update(state, {
			consignation: {
				isLoading: {
					$set: true,
				},
			},
		}),
	[ActionsTypes.VIEW_CONSIGNEMENT_CONTRACT_SUCCESS]: (state, _payload) => {
		return update(state, {
			consignation: {
				isLoading: {
					$set: false,
				},
				contractView: {
					$set: true,
				},
			},
		})
	},
	[ActionsTypes.VIEW_CONSIGNEMENT_CONTRACT_FAILURE]: (state, payload) => {
		return update(state, {
			consignation: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: payload.error,
				},
			},
		})
	},
	[ActionsTypes.RESET_CONSIGNATION]: (state) => {
		return update(state, {
			consignation: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: false,
				},
				items: {
					$set: {},
				},
				customer: {
					$set: {},
				},
				paging: {
					$set: {},
				},
				header: {
					$set: {},
				},
				update: {
					$set: false,
				},
				contractSend: {
					$set: false,
				},
				contractView: {
					$set: false,
				},
				transactionNumber: {
					$set: {},
				},
				isUpdated: {
					$set: false,
				},
			},
		})
	},
}

export default consignation
